import { Team } from '@crimsontide/core/client/interfaces'
import DotNetObject = DotNet.DotNetObject;

let dotNetObj: DotNetObject;
let cachedTeams: Team[];

export const TeamService = (() => {
  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getTeams = async (teamId?: string, useCache: boolean = true): Promise<Team[]> => {
    if (useCache && teamId == null && cachedTeams != null)
      return cachedTeams;

    return await fetch('/api/Team/get?' + new URLSearchParams({
      teamId: teamId?.toString() ?? '',
    }),
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF': '1',
        }
      }
    ).then(teams => teams.json());
  };

  return {
    setDotNetReference,
    getTeams,
  };
})();
